export const PROGRAM_TYPES = {
  DEGREE: 'DEGREE',
  MASTERTRACK: 'MASTERTRACK',
  PRODUCT: 'Degree',
};

// Status values corresponding to DegreeEnrollmentChecklistsV1Resource.completedItems
// (org_coursera_degreemarketing_checklist_DegreeEnrollmentChecklistItem)
// Note, ENROLLMENT_STATUSES is "statuses" plural because they're not mutually exclusive.
// Each status is a boolean.
export const ENROLLMENT_STATUSES = {
  SUBMIT_APPLICATION: 'SUBMIT_APPLICATION',
  PAY_APPLICATION_FEE: 'PAY_APPLICATION_FEE',
  APPLICATION_ACCEPTED: 'APPLICATION_ACCEPTED',
  ENROLL_IN_COURSES: 'ENROLL_IN_COURSES',
};

export const checklistStatusEnum = {
  noChecklistDefined: 'noChecklistDefined',
  checklistNotStartedYet: 'checklistNotStartedYet',
  checklistStarted: 'checklistStarted',
  checklistCompleted: 'checklistCompleted',
};

export const degreeUrlRoot = 'degrees';
export const certificateUrlRoot = 'professional-certificate';
export const mastertrackRoot = 'mastertrack';
export const certificatesRoot = 'certificates';

export default {
  degreeUrlRoot,
  certificateUrlRoot,
  mastertrackRoot,
  ENROLLMENT_STATUSES,
  certificatesRoot,
};
